export default __webpack_public_path__ + "static/media/Cooling_Tower.ddca600b.jpg";